import { render } from "./ItemList.vue?vue&type=template&id=a96a497c&scoped=true"
import script from "./ItemList.vue?vue&type=script&lang=js"
export * from "./ItemList.vue?vue&type=script&lang=js"

import "./ItemList.vue?vue&type=style&index=0&id=a96a497c&scoped=true&lang=css"
import "./ItemList.vue?vue&type=style&index=1&id=a96a497c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a96a497c"]])

export default __exports__